import styled from "styled-components";

import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../../constants/Styles";

const ErrorField = styled.div`
  color: ${COLORS.error};
  font-size: ${FONT_SIZE.size13};
  font-weight: ${FONT_WEIGHT.weight500};
`;

export { ErrorField };
